import { ChangeEvent, HTMLAttributes } from "react";
import { Input } from "./Field";
import { composeTailwindRenderProps, focusRing } from "./utils";

export type Props = Omit<HTMLAttributes<HTMLDivElement>, "onChange"> & {
  value?: string;
  onChange?: React.FormEventHandler<HTMLInputElement>;
  suffix?: React.ReactNode;
  ref?: React.Ref<HTMLInputElement>;
};

export function Search({ value, onChange, ref, suffix, ...props }: Props) {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange?.(e);
  };

  return (
    <div {...props}>
      <Input
        ref={ref}
        value={value}
        onChange={handleChange}
        className={composeTailwindRenderProps(
          focusRing,
          "h-8 w-full bg-none px-2 py-2 text-[11px]/[16px]",
        )}
        suffix={suffix}
        theme="none"
        placeholder="Søg..."
        aria-label="Søg..."
      />
    </div>
  );
}
